module.exports = __webpack_public_path__ + "assets/img/vr2.e443c0fc.jpg";